module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_3.d7262545.mp3";